import Alert from 'react-s-alert';
import store from 'store';

import PolyUtil from "../../../util/PolyUtil";
import {SubmissionError} from 'redux-form';

export const handleChangePassword = (password) => dispatch => {
    const user_type = store.get('type');
    const url = user_type === 'tenant' ? '/api/tenant/' : '/api/landlord/';

    const newPass = Object.assign({}, password);
    delete newPass.repeated_password;


    return PolyUtil.fetchWrapper(url,
        {
            method: 'PATCH',
            body: JSON.stringify({
                password: newPass.password
            })
        }
    ).then((data) => {
        Alert.success("Changed password!");
    }).catch((error) => {
        console.log('Error: ', error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });

};

export const handleChangeDefaultMessages = (messages) => dispatch => {
    return PolyUtil.fetchWrapper('/api/landlord/',
        {
            method: 'PATCH',
            body: JSON.stringify(messages)
        }
    ).then((data) => {
        Alert.success("Changed default messages!");
    }).catch((error) => {
        console.log('Error: ', error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};


// WEBPACK FOOTER //
// ./src/containers/settings/actions/settings.js